import Marquee from 'react-fast-marquee';

/**
 * TrustedBy strip — dark void-black theme with real airline logos.
 * Uses Kiwi's free public airline logo CDN. Marquees continuously.
 */

const AIRLINES = [
  { code: 'EK', name: 'Emirates' },
  { code: 'LH', name: 'Lufthansa' },
  { code: 'SQ', name: 'Singapore Airlines' },
  { code: 'QR', name: 'Qatar Airways' },
  { code: 'AF', name: 'Air France' },
  { code: 'KL', name: 'KLM' },
  { code: 'BA', name: 'British Airways' },
  { code: 'TK', name: 'Turkish Airlines' },
  { code: 'CX', name: 'Cathay Pacific' },
  { code: 'DL', name: 'Delta' },
  { code: 'NH', name: 'ANA' },
  { code: 'EY', name: 'Etihad' },
  { code: 'QF', name: 'Qantas' },
  { code: 'JL', name: 'Japan Airlines' },
  { code: 'AA', name: 'American' },
  { code: 'UA', name: 'United' },
  { code: 'AI', name: 'Air India' },
  { code: 'SU', name: 'Aeroflot' },
];

const LOGO_URL = (code) => `https://images.kiwi.com/airlines/128/${code}.png`;

export default function TrustedBy() {
  return (
    <section
      className="relative py-16 border-y border-white/8 overflow-hidden"
      style={{
        background:
          'radial-gradient(1000px 400px at 50% 50%, rgba(0,240,255,0.05) 0%, transparent 60%),' +
          'linear-gradient(180deg, #000 0%, #030303 50%, #000 100%)',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-white/45 font-semibold">
            <span className="text-[#00F0FF]">// </span>
            Booked, deployed and trusted by travel + tech teams at
          </div>
        </div>

        <div
          className="mt-8 relative"
          style={{
            maskImage:
              'linear-gradient(90deg, transparent, black 8%, black 92%, transparent)',
            WebkitMaskImage:
              'linear-gradient(90deg, transparent, black 8%, black 92%, transparent)',
          }}
        >
          <Marquee gradient={false} speed={40} pauseOnHover>
            {AIRLINES.map((a) => (
              <div
                key={a.code}
                className="flex items-center gap-3 mx-10 group"
                title={a.name}
              >
                <img
                  src={LOGO_URL(a.code)}
                  alt={a.name}
                  className="h-9 w-auto object-contain filter grayscale brightness-150 opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
                <span className="font-display font-bold text-sm text-white/50 group-hover:text-white transition-colors whitespace-nowrap">
                  {a.name}
                </span>
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
